


































































































































































































































































































import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import HomeMixin from "@/shared/componentTemplate/Home/HomeMixin.ts";

export default /*extend*/ {
	mixins: [HomeMixin],
	data: () => ({
		count: 0,
	}),
	computed: {
		preparedMenu() {
			return this.menus.filter((x) => x.showOnDefault);
		},
		notificationEvents() {
			return [
				{
					code: "openMallRequest",
					handler: (val) => this.$router.replace(`/request/${val}`),
				}
			];
		},
		notificationCounterEvents() {
			return [
				{
					code: "getNCount",
					handler: (val) => {this.count = Number(val)},
				}
			];
		},
	},
	watch: {
		chatId: {
			handler(val, oldVal) {
				if (val !== oldVal && val) {
					this.rightDrawer = false;
					this.openChatMenu = true;
				}
			},
			immediate: true,
		},
	},
};
